import React, { useEffect, useState } from 'react'
import API from 'src/app/api'

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
const SUPPORTED_COUNTRIES = new Set([
    'af',
    'al',
    'dz',
    'ad',
    'ao',
    'ag',
    'ar',
    'am',
    'aw',
    'au',
    'at',
    'az',
    'bs',
    'bh',
    'bd',
    'bb',
    'by',
    'be',
    'bz',
    'bj',
    'bt',
    'bo',
    'ba',
    'bw',
    'br',
    'bn',
    'bg',
    'bf',
    'bi',
    'kh',
    'cm',
    'ca',
    'cv',
    'cf',
    'td',
    'cl',
    'co',
    'km',
    'cr',
    'hr',
    'cy',
    'cz',
    'cd',
    'dk',
    'dj',
    'dm',
    'do',
    'ec',
    'eg',
    'sv',
    'gq',
    'ee',
    'et',
    'fj',
    'fi',
    'fr',
    'gf',
    'ga',
    'gm',
    'ge',
    'de',
    'gh',
    'gr',
    'gd',
    'gp',
    'gu',
    'gt',
    'gn',
    'gw',
    'gy',
    'ht',
    'hn',
    'hk',
    'hu',
    'is',
    'in',
    'id',
    'iq',
    'ie',
    'il',
    'it',
    'jm',
    'jp',
    'jo',
    'kz',
    'ke',
    'ki',
    'kw',
    'kg',
    'la',
    'lv',
    'lb',
    'ls',
    'lr',
    'ly',
    'li',
    'lt',
    'lu',
    'mo',
    'mk',
    'mg',
    'mw',
    'my',
    'mv',
    'ml',
    'mt',
    'mq',
    'mr',
    'mu',
    'mx',
    'md',
    'mc',
    'mn',
    'me',
    'ma',
    'mz',
    'mm',
    'na',
    'np',
    'nl',
    'nc',
    'nz',
    'ni',
    'ne',
    'ng',
    'no',
    'om',
    'pk',
    'pw',
    'ps',
    'pa',
    'pg',
    'py',
    'pe',
    'ph',
    'pl',
    'pt',
    'pr',
    'qa',
    'cg',
    're',
    'ro',
    'ru',
    'rw',
    'kn',
    'lc',
    'vc',
    'ws',
    'st',
    'sa',
    'sn',
    'rs',
    'sc',
    'sl',
    'sg',
    'sk',
    'si',
    'sb',
    'so',
    'za',
    'kr',
    'ss',
    'es',
    'lk',
    'sr',
    'sz',
    'se',
    'ch',
    'tw',
    'tj',
    'tz',
    'th',
    'tl',
    'tg',
    'to',
    'tt',
    'tn',
    'tr',
    'tm',
    'ug',
    'ua',
    'ae',
    'gb',
    'us',
    'uy',
    'uz',
    'vu',
    've',
    'vn',
    'ye',
    'zm',
    'zw',
])

const MobilePhoneInput = ({ handlePhoneInput, isCountryNotSupported }) => {
    const [country, setCountry] = useState('gb')
    useEffect(() => {
        API.settingsNew.getUserCountry().then((res) => {
            setCountry(res.data.alpha2Code.toLowerCase())
        })
    }, [])
    return (
        <PhoneInput
            country={country}
            inputClass="ant-input phone-number-input"
            buttonClass="country-select-button"
            dropdownClass="country-select-dropdown"
            inputProps={{
                disabled: isCountryNotSupported,
            }}
            onChange={(phone, country) =>
                handlePhoneInput(phone, country.dialCode, country.countryCode, SUPPORTED_COUNTRIES)
            }
        />
    )
}

export default MobilePhoneInput
